import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { SERVICES, HttpMethods } from '../../../services/api';
import { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../../rootReducer';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';
import { IVerifyPromotionalCodeData, IPromotionalCodeDiscount } from './interfaces';
import { isResponseError } from '../../utils';

export const VERIFY_PROMOTIONAL_CODE_THUNK_PREFIX = 'account/verifyPromotionalCode';
export const verifyPromotionalCode: AsyncThunk<IPromotionalCodeDiscount | undefined, IVerifyPromotionalCodeData, ThunkAPI> =
  createAsyncThunk(
    VERIFY_PROMOTIONAL_CODE_THUNK_PREFIX,
    async (data, thunk) => {
      if (!isFeatureEnabled(Features.PromotionalCodes)) {
        thunk.dispatch({
          type: 'DO_NOTHING'
        });
        return;
      }
      try {
        const response = await basicApiAsyncThunkCreator<IPromotionalCodeDiscount, IVerifyPromotionalCodeData>({
          endpoint: 'subscription/validate-pro-subscription-code',
          microservice: SERVICES.USERS_SERVICE,
          authenticated: true,
          method: HttpMethods.Post,
          contentType: 'application/json'
        })(data, thunk);
        return response;
      } catch (err) {
        if (isResponseError(err)) {
          return thunk.rejectWithValue(err.errors || err.message);
        } else if (typeof err === 'string') {
          return thunk.rejectWithValue(err);
        }
        return thunk.rejectWithValue('Something went wrong validating your code');
      }
    }
  );
